import { createCachedSelector } from 're-reselect';
import { get, map, max } from 'lodash/fp';
import blockScenarioDataSelector from './blockScenarioDataSelector';
import blockValueSelector from './blockValueSelector';

const sizeMaxSelector = createCachedSelector(
  blockScenarioDataSelector,
  blockValueSelector,
  (data, blockValue) => {
    const sizeColumn = get(
      [get('visualisation', blockValue), 'size', 'column'],
      blockValue,
    );

    if (!sizeColumn) {
      return undefined;
    }

    return max(map(sizeColumn, data));
  },
)((state, props) => props.blockId);

export default sizeMaxSelector;
